import $ from 'jquery';
import drp from  'components/daterangepicker';
import anim from 'core/loading-animation';
import ReviewsTable from 'components/reviews-table';
import formatting from 'core/formatting';
import FilterBox from 'components/filter-box';
import keyMetrics from 'components/metrics';
import browser_storage from 'core/browser-storage';
import automationBanner from 'components/automation-banner';

let nodes = {
    metrics: {
        main: document.querySelector(".key-figures"),
        wrap: document.querySelector(".metrics-wrap"),
        metricsContainer: document.querySelector(".metrics-wrap .metrics"),
        cards: document.querySelectorAll(".metrics-wrap .metrics .card"),
        header: document.querySelector(".key-figures header"),
        benchmarksToggle: document.querySelector("#toggleBenchmarks"),
    }
}

let metrics = keyMetrics.init(nodes.metrics, "reviews");
metrics.initBenchmarks();

window.addEventListener("resize", metrics.adjustMetricsHeight);

// drp.create();

automationBanner();
class Reviews {
    constructor () {
        this.filterbox = new FilterBox('csat', 'review', (data) => {if(this.table) this.table.update(data)}, ()=>{
            drp.reset(this);
            this.getFilters();
        });
        this.table = new ReviewsTable('#reactions', anim, this.getFilters.bind(this), this.updateEvent.bind(this));
    }

    initMetrics() {
        let metrics = Object();
        metrics['response_rate'] = 0;
        metrics['net_csat_score'] = 0;
        metrics['total'] = 0;
        metrics['positive'] = 0;
        metrics['negative'] = 0;
        metrics['neutral'] = 0;
        metrics['net_csat_score_all'] = 0;
        metrics['total_all'] = 0;
        metrics['positive_all'] = 0;
        metrics['negative_all'] = 0;
        metrics['neutral_all'] = 0;
        metrics['answered'] = 0;
        metrics['answered_all'] = 0;
        return metrics;
    }

    updateEvent(data) {
        if('metrics' in data) {
            this.updateMetrics(data.metrics, data.benchmarks);
            metrics.adjustMetricsHeight();
        }
        if ('tags' in data) {
            this.filterbox.updateTags(data.tags);
        }
        if ('agents' in data) {
            this.filterbox.updateAgents(data.agents);
        }

        // construct date string for status bar
        let dateStatus = document.querySelector(".status-wrap .date-range .value");
        
        if(drp.getPreset()) {
            dateStatus.innerHTML = drp.getPreset().toLowerCase();
        } else {
            dateStatus.innerHTML = `${drp.getStartDate().format('MMM DD, YYYY')} - ${drp.getEndDate().format('MMM DD, YYYY')}`;
        }

        setTimeout(() => {
            this.table.resizeHandler();
        }, 1);
    }

    updateMetrics(metrics, benchmarks) {
        if(!metrics){
            metrics = this.initMetrics();
        }
        $('#kf-net-csat-score-current-mini').text(formatting.asNetCsatScore(metrics.net_csat_score));
        $('#kf-response-rate-mini').text(formatting.asResponseRate(metrics.response_rate));
        $('#kf-sum-current-mini').text(formatting.asReviewCount(metrics.answered));

        $('#kf-positive-current-mini').text(formatting.asReviewCount(metrics.positive));
        $('#kf-neutral-current-mini').text(formatting.asReviewCount(metrics.neutral));
        $('#kf-negative-current-mini').text(formatting.asReviewCount(metrics.negative));

        $('#kf-response-rate').html(`${formatting.asResponseRate(metrics.response_rate)}<div class="symbol">%</div>`);
        $('#kf-response-rate-answered').text(formatting.asReviewCount(metrics.answered));
        $('#kf-response-rate-total').text(formatting.asReviewCount(metrics.total));
        $('#kf-net-csat-score-current').text(formatting.asNetCsatScore(metrics.net_csat_score));
        $('#kf-net-csat-score-total-ratio').text(formatting.asNetCsatScore(metrics.net_csat_score_all));
        $('#kf-sum-current').text(formatting.asReviewCount(metrics.answered));
        $('#kf-sum-total').text(formatting.asReviewCount(metrics.answered_all));

        $('#kf-positive-current-ratio').text(formatting.asPercentage(formatting.cleanPercentageFraction(metrics.positive, metrics.answered)));
        $('#kf-positive-current').text(formatting.asReviewCount(metrics.positive));
        $('#kf-positive-total').text(formatting.asReviewCount(metrics.positive_all));
        $('#kf-positive-total-ratio').text(formatting.asPercentage(formatting.cleanPercentageFraction(metrics.positive_all, metrics.answered_all)));

        $('#kf-neutral-current-ratio').text(formatting.asPercentage(formatting.cleanPercentageFraction(metrics.neutral, metrics.answered)));
        $('#kf-neutral-current').text(formatting.asReviewCount(metrics.neutral));
        $('#kf-neutral-total').text(formatting.asReviewCount(metrics.neutral_all));
        $('#kf-neutral-total-ratio').text(formatting.asPercentage(formatting.cleanPercentageFraction(metrics.neutral_all, metrics.answered_all)));

        $('#kf-negative-current-ratio').text(formatting.asPercentage(formatting.cleanPercentageFraction(metrics.negative, metrics.answered)));
        $('#kf-negative-current').text(formatting.asReviewCount(metrics.negative));
        $('#kf-negative-total').text(formatting.asReviewCount(metrics.negative_all));
        $('#kf-negative-total-ratio').text(formatting.asPercentage(formatting.cleanPercentageFraction(metrics.negative_all, metrics.answered_all)));

        // benchmarks 
        if(benchmarks) {
            let scoreBenchmarks = document.querySelector(".card.main-score .benchmarking");
            let responseRateBenchmarks = document.querySelector(".card.response-rate .benchmarking");

            let applyBenchmarks = (benchmarkWrapper, type) => {
                let mainScoreBenchmark = benchmarks[`${type}_median`];
                let topTenBenchmark = benchmarks[`top_${type}_median`];

                 // benchmark elements
                let allCompaniesElement = benchmarkWrapper.querySelector(".bm-score.all");
                let topTenElement = benchmarkWrapper.querySelector(".bm-score.top10");
                let mainDeltaElement = benchmarkWrapper.querySelector(".diff.all");
                let topDeltaElement = benchmarkWrapper.querySelector(".diff.top10");

                mainDeltaElement.classList.remove("negative", "positive");
                topDeltaElement.classList.remove("negative", "positive");
                allCompaniesElement.innerHTML = "N/A";
                topTenElement.innerHTML = "-";
                mainDeltaElement.innerHTML = "N/A";
                topDeltaElement.innerHTML = "N/A";

                if(mainScoreBenchmark) {
                    let percentSign = type === "response_rate" ? "%" : "";
                    benchmarkWrapper.querySelector(".bm-score.all").innerText = mainScoreBenchmark.toFixed(1) + percentSign;

                    if(topTenBenchmark) {
                        benchmarkWrapper.querySelector(".bm-score.top10").innerText = topTenBenchmark.toFixed(1) + percentSign;
                    }

                    let customerScore = type === "score" ? metrics.net_csat_score : metrics.response_rate; 
                    
                    let renderDeltas = (element, benchmarkScore) => {
                        let delta = customerScore - benchmarkScore;
                        let symbol = "";

                        if(delta === 0) delta = 0;

                        if(delta < 0) {
                            element.classList.add("negative");
                            symbol = "-";
                        }

                        if (delta > 0) {
                            element.classList.add("positive");
                            symbol = "+";
                        }

                        element.innerHTML = `<div class="symbol">${symbol}</div>${(Math.abs(delta)).toFixed(1)}`;
                    }

                    // apply delta values for All Companies
                    renderDeltas(mainDeltaElement, mainScoreBenchmark);

                    if(topTenBenchmark) {
                        // apply delta values for Top 10%
                        renderDeltas(topDeltaElement, topTenBenchmark);
                    }
                }
            }
            
            // apply benchmarks to CSAT Main Score
            applyBenchmarks(scoreBenchmarks, "score");
            // apply benchmarks to CSAT Response Rate
            applyBenchmarks(responseRateBenchmarks, "response_rate");
        } else {
            // no data - render deltas as 0
            let deltas = document.querySelectorAll(".card .benchmarking .diff");
            deltas.forEach(delta => {
                delta.classList.remove("negative", "positive");
                delta.innerHTML = "0.0";
            })
        }
    }

    getFilters() {
        return this.filterbox.getFilterData();
    }

}

export default new Reviews();
